import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { SurveyWithVariantCheckSchema } from '../../entities/survey';
import { SurveyTogglesSchema } from '../../shared/survey-toggles';
/**
 * Get Survey Request Schema
 * GET /api/v2/survey/:id
 * Survey ID provided as URL parameter
 */ export const GetSurveyRequestSchema = z.void();
/**
 * Get Survey Response Schema
 * Returned on successful retrieval
 * Contains the requested survey object
 *
 * The tenant's question toggles ride along because the dialog decides what to
 * ask — and, for "Ja, genau so", whether the answer ENDS the survey — off them.
 * Derived client-side from the organization-settings query they read `classic:
 * false` while that query is in flight or has failed, which silently completes
 * the row with no classic answers; a completed verdict is immutable (ADR 0022),
 * so that loss is not recoverable. The server holds the settings anyway.
 */ export const GetSurveyResponseSchema = z.object({
    survey: SurveyWithVariantCheckSchema,
    toggles: SurveyTogglesSchema
});
/**
 * Get Survey Error Schema
 * Returned when retrieval fails
 */ export const GetSurveyErrorSchema = BaseErrorSchema;

//# sourceMappingURL=get-survey.schema.js.map